module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d12e97"
    }
  }, [_vm._v("Other Novels by Denise Hunter Include")]), _vm._v(" "), _c('p', {
    staticClass: "extc",
    attrs: {
      "id": "d12e99"
    }
  }, [_c('i', [_vm._v("The Convenient Groom")]), _c('br'), _c('i', [_vm._v("Surrender Bay")]), _c('br'), _c('i', [_vm._v("Finding Faith")]), _c('br'), _c('i', [_vm._v("Saving Grace")]), _c('br'), _c('i', [_vm._v("Mending Fences")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c96168d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hunt_9781595542595_epub_c4_r1.vue
// module id = 63
// module chunks = 0